const ALLOWED_FORMATS = {
  PDF: 'pdf',
  IMAGES: 'images',
};

export default ALLOWED_FORMATS;
